import { render, staticRenderFns } from "./BookingClaim.vue?vue&type=template&id=0e9dc505&scoped=true"
import script from "./BookingClaim.vue?vue&type=script&lang=js"
export * from "./BookingClaim.vue?vue&type=script&lang=js"
import style0 from "./BookingClaim.vue?vue&type=style&index=0&id=0e9dc505&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9dc505",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e9dc505')) {
      api.createRecord('0e9dc505', component.options)
    } else {
      api.reload('0e9dc505', component.options)
    }
    module.hot.accept("./BookingClaim.vue?vue&type=template&id=0e9dc505&scoped=true", function () {
      api.rerender('0e9dc505', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/components/BookingHeader/BookingClaim.vue"
export default component.exports